import { useContext } from 'react';
import { createOrUnlockAccountData } from '../../create-account/createAccountContext';
import getDateStringFromObject from '../functions/getDateStringFromObject';
import { stripInvalidMbiChars } from '../functions/stripInvalidMbiChars';
import { DateObject } from '../objects/models/date.field.value';
import useAxios from './useAxios';
import { CreateUnlockAccountResponse } from './useCreateAccountApi';

export default function useUnlockAccountApi() {
    const axios = useAxios();
    const { data } = useContext(createOrUnlockAccountData);

    const step1 = async (mbi: string, effectiveDate: DateObject, effectiveDatePart: 'A' | 'B') => {
        return axios.call<CreateUnlockAccountResponse>(
            'POST',
            '/account/api/unlock-account/step/1',
            {
                effectiveDate: getDateStringFromObject(effectiveDate),
                effectiveDatePart: effectiveDatePart.toLowerCase(),
                mbi: stripInvalidMbiChars(mbi),
            },
        );
    };

    const step2 = async (lastName: string, dateOfBirth: DateObject, zipCodeOrCity: string) => {
        return axios.call(
            'POST',
            '/account/api/unlock-account/step/2',
            {
                dateOfBirth: getDateStringFromObject(dateOfBirth),
                effectiveDate: getDateStringFromObject(data.coverageStartDate),
                effectiveDatePart: data.part.toLowerCase(),
                lastName,
                mbi: stripInvalidMbiChars(data.medicareNumber),
                zipCodeOrCity,
            },
        );
    };

    const step3 = async (password: string, challengeQuestion: string, challengeAnswer: string) => {
        return axios.call(
            'POST',
            '/account/api/unlock-account/step/3',
            {
                challengeQuestionAndAnswers: [{
                    answer: challengeAnswer,
                    question: challengeQuestion,
                }],
                dateOfBirth: getDateStringFromObject(data.dateOfBirth),
                effectiveDate: getDateStringFromObject(data.coverageStartDate),
                effectiveDatePart: data.part.toLowerCase(),
                lastName: data.lastNameWithSuffix,
                mbi: stripInvalidMbiChars(data.medicareNumber),
                password,
                zipCodeOrCity: data.zipCodeOrCity,
            },
        );
    };

    return {
        step1,
        step2,
        step3,
    };
}
